<template>
  <div>
    <div>
      <div class="row">
        <div class="col-sm-1">
          <h2 class="text-center">{{ course.name }}</h2>
        </div>
        <div class="col-sm-9"></div>
      </div>
      <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-9">
          <span v-html="course.description"></span>
        </div>
        <div class="col-sm-1"><h3>Preis pro Person pro zwei Stunden: {{course.price}}€</h3></div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <h3>Gewählte Termine</h3>
        <ul>
          <li v-for="appointment in getSelectedAppointments()" :key="appointment.id">
            {{ appointment.begin.toLocaleString() }}
          </li>
        </ul>
        <div v-if="selectedAppointments.length>0">
        <button class="btn btn-dark" v-on:click="goToRegistration">
          Die gewählten Termine anmelden.
        </button>
        </div>
      </div>
      <div class="col-sm-10">
        <div class="row border border-dark p-3" v-for="day in days" v-bind:key="day.getFullYear()&&day.getMonth()&&day.getDate()">
          <div class="col-sm-1 text-break"><b>{{day.toLocaleDateString()}}</b></div>
          <div class="col-sm-1" style="display: flex; justify-content: center;"
               v-for="appointment in getAppointmentsByDay(day)" v-bind:key="appointment.id"
          >
            <div style="margin: 5px; padding: 5px; width: 350px">
              <div class="rounded bg-secondary text-light" >
                <p>{{appointment.begin.getHours()}} - {{ appointment.end.getHours() }} </p>
                <div class="text-dark" v-if="checkBooked(appointment.id)">
                  <p>
                    <b>Besetzt</b>
                  </p>
                </div>
                <div v-else>
                    <button
                      class="btn btn-sm"
                      :class="isSelected(appointment.id) ? 'btn-outline-dark' : 'btn-light'"
                      @click="toggleAppointment(appointment.id)"
                    >
                      Wählen
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <infinite-loading @infinite="populateCourses"></infinite-loading>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import InfiniteLoading from 'vue-infinite-loading'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { Course } from '../../entities/Course'
import { Appointment } from '@/entities/Appointment'
import { CourseBooking } from '../../entities/CourseBooking'
import { CourseService } from '@/services/CourseService'
import { AppointmentsService } from '@/services/AppointmentsService'

@Component({
  components: {
    InfiniteLoading
  }
})
export default class CoursesList extends Vue {
  @Prop() private readonly courseName!:string
  private course = Course.emptyCourse()
  private appointments:Appointment[] = []
  private selectedAppointments:Appointment[] = []
  private page = 1
  private pageSize = 1
  private courseBookings: CourseBooking[] = []
  private days: Date[] = []
  private colClass = 'col-sms'
  private courseId = process.env.VUE_APP_SIMULATOR_COURSE_ID

  mounted () {
    this.$store.commit('resetState')
    this.resetFilter()
    this.getCourseById(this.courseId)
  }

  resetFilter () {
    this.appointments = []
    this.course = Course.emptyCourse()
    this.page = 1
  }

  getCourseById (id:number) {
    CourseService.getCourseById(id)
      .then(response => {
        this.course = response.data
        this.$store.commit('updateCoursesList', this.course)
      })
  }

  getCourseBookingByAppointmentId (appointmentId:number) {
    return this.$store.getters.getPaidCourseBookingByAppointmentId(appointmentId)
  }

  checkBooked (appointmentId:number) {
    // const courseBookings:CourseBooking[] = this.getCourseBookingByAppointmentId(appointmentId)
    const courseBookings:CourseBooking[] =
      this.courseBookings.filter(courseBooking => courseBooking.appointmentId === appointmentId && courseBooking.paid === true)
    if (courseBookings.length <= 0) {
      return false
    }
    const index = this.appointments.findIndex(appointment => appointment.id === appointmentId)
    if (index === -1) {
      return false
    }
    const appointment:Appointment = this.appointments[index]
    return (courseBookings.length >= appointment.availablePlaces)
  }

  getDays () {
    const days:Date[] = []
    this.appointments.forEach((appointment, index) => {
      if (!this.containsDate(this.days, appointment.begin)) {
        const d = new Date(appointment.begin)
        d.setHours(0, 0, 0, 0)
        days.push(d)
      }
    })
    console.log('getDays: days.length ' + days.length)
    return days
  }

  containsDate (dates: Date[], target: Date): boolean {
    return dates.some(
      d =>
        d.getFullYear() === target.getFullYear() &&
        d.getMonth() === target.getMonth() &&
        d.getDate() === target.getDate()
    )
  }

  isSameDay (d1: Date, d2: Date) {
    return (
      new Date(d1).setHours(0, 0, 0, 0) ===
      new Date(d2).setHours(0, 0, 0, 0)
    )
  }

  getAppointmentsByDay (day:Date) {
    return this.appointments.filter(appointment => this.isSameDay(appointment.begin, day))
  }

  isSelected (appointmentId:number) {
    return this.$store.getters.getIsSelectedAppointment(appointmentId)
  }

  getSelectedAppointments () {
    return this.$store.getters.getSelectedAppointments()
  }

  toggleAppointment (appointmentId:number) {
    this.$store.commit('toggleAppointment', appointmentId)
    this.selectedAppointments = this.$store.getters.getSelectedAppointments()
  }

  goToRegistration () {
    this.$router.push({ name: 'user_registration' })
  }

  populateCourses (state:any) {
    const daysToLoad = this.getDays()
    AppointmentsService.getAppointmentsByCourseId(this.courseId, this.page, this.pageSize)
      .then(appointmentsLoaded => {
        if (appointmentsLoaded.length) {
          const cuerrentDate = new Date()
          const futureAppointmentsLoaded =
            appointmentsLoaded.filter(appointment => appointment.begin > cuerrentDate)
          this.appointments.push(...futureAppointmentsLoaded)
          this.$store.commit('updateAppointmentList', futureAppointmentsLoaded)
          this.days.push(...daysToLoad)
          futureAppointmentsLoaded.forEach((appointment, index) => {
            this.courseBookings.push(...appointment.courseBookingList)
            this.$store.commit('updateCoursesBookingList', ...appointment.courseBookingList)
          })
          state.loaded()
          this.page += 1
        } else {
          state.complete()
        }
      })
      .catch(error => {
        console.error('Error fetching appointments:', error)
      })
  }
}
</script>

<style scoped>

</style>
